/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS203: Remove `|| {}` from converted for-own loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import uniq from "lodash/uniq";
import Analytics from "analytics/util/Analytics";
import Actions from "okpay/actions/Actions";
import getInitialState from "okpay/stores/getInitialState";
import StoreUtil from "shared/util/StoreUtil";
import C from "okpay/util/Constants";
import ClientStats from "shared/util/ClientStats";

function __guard__(value, transform) {
	return (typeof value !== "undefined" && value !== null) ? transform(value) : undefined;
}

const _getAnalyticsProductName = (productId, feature) => {
	if (productId === "spotlight") {
		return "Boost Token";
	}

	if (productId === "incognito") {
		return "Incognito";
	}

	if (productId.indexOf("alist") !== -1) {
		if (feature === 10004) {
			return "Alist Premium";
		} else {
			return "Alist Basic";
		}
	}
};

const Store = StoreUtil.createStore(Actions, {
	data: getInitialState(),

	// TODO: Enhanced Alist modals should be implemented in here!
	// Not through some weird message-passing crap!


	// ==========================================================================
	// onUpdate
	// --------------------------------------------------------------------------

	/*
		!!!!
		Note that nothing in or called by this function can call @set!
		This can cause an infinite loop!
		Just edit @data directly!
		Better yet, all functions called by this should TAKE SIMPLE INPUTS
		and RETURN SIMPLE OUTPUTS, and THIS FUNCTION should set @data!
		Thanks chief!
	*/
	onUpdate(bundle) {
		if (bundle.product != null) {
			// product details
			this.data.product.options.forEach((option, i) => {
				this.data.product.options[i] = this.addOptionDisplayInfo(option);
			});

			this.data.selectedOption = this.getSelectedOption();
		}

		// if they have useBillingInfo set, set the billingType to that
		if (bundle.useBillingInfo) {
			this.data.billingType = this.data.useBillingInfo;
		}

		// if there's a passed in active payment mehtod, set the billingType to that
		if (bundle.activePaymentMethod) {
			this.data.billingType = C.activePaymentMethod[bundle.activePaymentMethod];
		}

		// card form validation
		if ((this.data.billingType === C.billingTypes.card) && !this.data.useBillingInfo) {
			this.data.cardNumber = this.getNumbersOnly(this.data.cardNumber);
			this.data.cardType = this.guessCardType(this.data.cardNumber);
			this.data.expirationDate = this.getExpirationDate(this.data.expiration);

			// names
			const { first, last } = this.getNames(this.data.name);
			this.data.firstName = first || "-";
			this.data.lastName = last || "-";

			// this function sets @data because it'd be awkward not to
			// (what with the per-field error state-changing).
			// so take care in there!
			this.data.isPaymentValid = this.validateFields(bundle);
		} else {
			this.data.isPaymentValid = true;
		}

		// dedupe cfs
		if (bundle.cf != null) {
			this.data.cf = uniq(this.data.cf);
		}

		// calculate paypal status
		if (!this.data.isSuccessful) {
			const isPaypal = this.data.billingType === C.billingTypes.paypal;
			let usePaypalLink = isPaypal && this.data.selectedOption.paypalLink && !this.data.hasPaypal;
			const isSubscription = this.data.product.feature ||
				(this.data.productId && (this.data.productId.indexOf("alist") !== -1));

			// okay, this is fucked.
			// if they HAVE paypal and they're trying to buy a SUBSCRIPTION
			// use the paypal link.
			// fuck the paypal implementation.
			if (
				isPaypal &&
				this.data.selectedOption.paypalLink &&
				this.data.hasPaypal &&
				isSubscription
			) {
				usePaypalLink = true;
			}

			this.data.usePaypalLink = usePaypalLink;
		}

		// a lot of properties can have billing errors so just run this always
		this.data.billingError = this.getBillingError();
	},


	// ==========================================================================
	// Helpers
	// --------------------------------------------------------------------------

	monify(cents) {
		return (cents / 100).toFixed(2);
	},


	// ==========================================================================
	// Square product details
	// --------------------------------------------------------------------------

	getSelectedOption() {
		return this.data.product.options[this.data.product.optionPicked];
	},

	addOptionDisplayInfo(option) {
		// add properties we need for display:
		// { displayPrice, displayTax, displayTotal, displayUnitPrice }

		let displayUnitPrice;
		const { name, price, units } = option;

		const tax = Math.floor(price * (this.data.taxRate || 0));
		const total = price + tax;

		const displayPrice = this.monify(price);
		const displayTax = tax ? this.monify(tax) : null;
		const displayTotal = this.monify(total);

		if (units) {
			const unitPrice = price / units;
			displayUnitPrice = this.monify(unitPrice);
		}

		const update = {
			displayUnitPrice,
			displayPrice,
			displayTax,
			displayTotal,
		};

		return { ...option, ...update };
	},


	// ==========================================================================
	// Sanitize some fields
	// --------------------------------------------------------------------------

	getNames(name) {
		// first name = everything before the first space
		let first;
		let last;
		const spaceIndex = name.indexOf(" ");

		if (spaceIndex !== -1) {
			first = name.substr(0, spaceIndex);
			last = name.substr(spaceIndex + 1);
		} else {
			first = name;
			last = "";
		}

		return { first, last };
	},

	getNumbersOnly(number) {
		return number.replace(/[^\d]/gi, "");
	},

	getExpirationDate(_expirationString) {
		let expirationString = _expirationString;
		const now = new Date();

		// kill all non-numbers
		expirationString = expirationString.replace(/[^\d]/gi, "");

		// Cut out if they don't have 4 digits yet
		if (expirationString.length !== 4) {
			return null;
		}

		// split months and days
		let year = expirationString.slice(2, 4);
		let month = expirationString.slice(0, 2);

		// make into an int
		year = parseInt(year, 10) + 2000;
		month = parseInt(month, 10);

		// test out simple shit
		if (!month || (month > 12)) {
			return null;
		}

		// get date from that
		const expirationDate = new Date(year, month);

		return expirationDate;
	},

	getBillingError() {
		let errorCount = 0;
		let billingError = null;

		// if they ahve an "other error," show that!
		if (this.data.otherError) {
			return this.data.otherError;
		}

		// check fields for errors first
		C.fields.forEach((field) => {
			if (this.data[`${field}Error`]) {
				billingError = this.data[`${field}Error`];
				errorCount += 1;
			}
		});

		// then check the other error
		if (this.data.otherError) {
			billingError = this.data.otherError;
			errorCount += 1;
		}

		// if there were a ton of errors, fix that shit
		if (errorCount > 1) {
			billingError = "Some information is missing or incorrect.";
		}

		// add some sugar
		if (billingError) {
			billingError = `Oops! ${billingError}`;
		}

		return billingError;
	},


	// ==========================================================================
	// Validate form fields
	// --------------------------------------------------------------------------

	validateFields(bundle) {
		// this function gets called @onUpdate so it can't use @set.
		// so take care!
		let isValid = true;

		C.fields.forEach((field) => {
			// skip address
			if ((field === "address") && !this.data.showAddress) {
				return;
			}

			if (bundle[`${field}Error`]) {
				isValid = false;
			} else if (this.data[field] === "") {
				this.data[`${field}Error`] = C.errorText[field];
				isValid = false;
			}
		});

		// validate expiration date
		if (!this.data.expirationDate) {
			isValid = false;
			this.data.expirationError = C.errorText.expiration;
		} else if (this.data.expirationDate < new Date()) {
			isValid = false;
			this.data.expirationError = C.errorText.expiration;
		}

		return isValid;
	},


	guessCardType(cc) {
		let cardType;
		const amex = /^3[47]?/;
		const visa = /^4/;
		const mast = /^5[1-5]?/;
		const disc = /^6[05]?/;
		const none = /^([^3-6]|5[^1-5]|3[^47]|6[^05])/;

		if (visa.test(cc)) {
			if (cc.length <= 16) {
				cardType = C.cardTypes.visa;
			} else {
				cardType = C.cardTypes.none;
			}
		} else if (mast.test(cc)) {
			if (cc.length <= 16) {
				cardType = C.cardTypes.mast;
			} else {
				cardType = C.cardTypes.none;
			}
		} else if (amex.test(cc)) {
			if (cc.length <= 15) {
				cardType = C.cardTypes.amex;
			} else {
				cardType = C.cardTypes.none;
			}
		} else if (disc.test(cc)) {
			if (cc.length <= 16) {
				cardType = C.cardTypes.disc;
			} else {
				cardType = C.cardTypes.none;
			}
		} else if (none.test(cc)) {
			cardType = C.cardTypes.none;
		} else {
			cardType = C.cardTypes.all;
		}

		return cardType;
	},


	// ==========================================================================
	// Actions
	// --------------------------------------------------------------------------

	onChangeBillingType(billingType) {
		this.set({
			billingType,
		});
	},

	onRejectBillingInfo() {
		this.set({ useBillingInfo: false });
	},

	onUpdateCfs(cfs = []) {
		this.set({ cf: this.data.cf.concat(cfs) });
	},

	onClose() {
		this.set({ isActive: false });

		// try to close the controller, if it exists
		__guard__(window[`${this.get("productId")}_controller`], (x) => x.close());
	},

	onEnableFakePayment(fakePayment) {
		console.log("this is the fake payment: ", fakePayment);
		this.set({ fakePayment });
	},

	onUpdateField(bundle) {
		let shouldUpdate = true;

		// make sure this bundle is updating only this field
		Object.keys(bundle || {}).forEach((name) => {
			const value = bundle[name];

			if (C.fields.indexOf(name) === -1) {
				shouldUpdate = false;
			}
		});

		if (shouldUpdate) {
			this.set(bundle);
		}
	},


	// ==========================================================================
	// A-List Packages
	// --------------------------------------------------------------------------

	onSwitchSelectedOption(optionPicked) {
		const product = ({ ...this.get("product") });
		product.optionPicked = optionPicked;
		this.set({ product });
	},


	// ==========================================================================
	// PAYMENT
	// --------------------------------------------------------------------------

	onConfirmPaypal() {
		const productId = this.get("productId");
		const price = this.data.selectedOption.price / 100;
		const { units } = this.data.selectedOption;
		const { feature } = this.data.product;
		const productName = _getAnalyticsProductName(productId, feature);

		const data = {
			"Gross proceeds in local currency": price,
			"Product": productName,
		};

		if (feature) {
			data["Plan duration in months"] = units;
		} else {
			data["Number of Boost tokens purchased"] = units;
		}

		Analytics.logUIEvent(
			Analytics.eventNames.purchasesSelectSubscribePaypal,
			{ data },
		);
	},


	onConfirmPurchase() {
		this.set({
			isSubmitting: true,
			hasSubmitted: true,
			billingError: null,
			nameError: null,
			zipCodeError: null,
			cardNumberError: null,
			securityCodeError: null,
			expirationError: null,
			addressError: null,
			otherError: null,
		});

		const productId = this.get("productId");
		const price = this.data.selectedOption.price / 100;
		const { units } = this.data.selectedOption;
		const { feature } = this.data.product;
		const productName = _getAnalyticsProductName(productId, feature);

		const data = {
			"Gross proceeds in local currency": price,
			"Product": productName,
		};

		if (feature) {
			data["Plan duration in months"] = units;
		} else {
			data["Number of Boost tokens purchased"] = units;
		}

		Analytics.logUIEvent(
			Analytics.eventNames.purchasesSelectedConfirmPurchaseOnBillingInfo,
			{ data },
		);

		if (productId.indexOf("alist") !== -1) {
			const platform = process.env.PLATFORM === "desktop" ? "desktop" : "mobile";

			ClientStats.update({
				statname: `purchases - platform:${platform} - product:alist - state:control - purchase submitted`,
				skipDelay: true,
				unique: true,
			});
		}
	},


	onConfirmPurchaseCompleted(params, response) {
		const productId = this.get("productId");

		const gaCategoryMap = {
			incognito: "Incognito",
			spotlight: "Boosts",
		};

		if ((this.data.selectedOption != null ? this.data.selectedOption.price : undefined) != null) {
			const price = this.data.selectedOption.price / 100;
			const { units } = this.data.selectedOption;

			const platform = process.env.PLATFORM === "desktop" ? "desktop" : "mobile";

			if (productId === "incognito") {
				Analytics.logUIEvent(
					Analytics.eventNames.purchasesSubscribedToIncognito,
					{
						data: {
							"Gross proceeds in local currency": price,
							"Plan duration in months": units,
						},
					},
				);
			}

			if (productId.indexOf("alist") !== -1) {
				ClientStats.update({
					statname: `purchases - platform:${platform} - product:alist - state:control - purchase successful`,
					skipDelay: true,
					unique: true,
				});
			}
		}

		this.set({
			isSubmitting: false,
			isSuccessful: true,
			successResponse: response,
		});
	},

	onConfirmPurchaseFailure(params, errors = []) {
		if (errors != null ? errors.isAlreadyRunning : undefined) {
			return;
		}

		// if we they were using existing info, kick them to the CC form
		this.set({
			isSuccessful: false,
			isSubmitting: false,
			useBillingInfo: false,
		});

		const hasOutdatedPaypal = (errors.length === 1) && (errors[0].code === "STORED_PAYPAL_INVALID");

		// check if the only error is an out-of-date error code
		if ((this.get("billingType") === C.billingTypes.paypal) && hasOutdatedPaypal) {
			this.set({
				hasPaypal: false,
				otherError: "Sorry, your stored PayPal information is out of date. Try again!",
				openPaypalAgain: true,
			});
		} else {
			// if there's some error, switch to the card form to show the error.
			let errorResponse;
			this.set({ billingType: C.billingTypes.card });

			errors.forEach((error) => {
				errorResponse = this.processError(error);
			});
		}
	},


	// ==========================================================================
	// Error handling
	// --------------------------------------------------------------------------

	processError(error) {
		// check if this is a field error
		let field;
		let update;
		let shouldShowError = true;

		if (error.code != null) {
			Object.keys(C.fieldErrorMap || {}).forEach((field) => {
				const errors = C.fieldErrorMap[field];

				if ((errors[error.code] == null)) { return; }

				update = {};
				update[field] = error.text || C.errorText[field];
				this.set(update);

				shouldShowError = false;
			});
		}

		if (!shouldShowError) { return; }

		// otherwise, return a generic error
		if (error.text != null) {
			update = {
				otherError: error.text || C.errorText[field],
			};
			this.set(update);
			return;
		} else {
			this.set({ otherError: C.errorText.form });
		}
	},
});

export default Store;

// Help debug the store
window.OkPayStore = Store;



// WEBPACK FOOTER //
// ./src/reflux/okpay/stores/Store.js